// @flow
import * as React from 'react'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import CheckIcon from '../shared/icons/CheckIcon'
import { colors } from '@components/shared/colors'
import ThemeContext from '@components/shared/ThemeContext'

export const PromoApplied = (props: {
  promoCode: string,
  textColor?: string,
  checkColor?: string,
  checkBackgroundColor?: string,
  clearPromo?: () => void
}): React.Node => {
  const theme = React.useContext(ThemeContext)
  return (
    <>
      <TopRow>
        <PromoCodeContainer>
          <IconContainer checkBackgroundColor={theme === 'pink' ? colors.white : props.checkBackgroundColor}>
            <CheckIcon color={props.checkColor || theme === 'pink' ? colors.pink : colors.midnightBlue} />
          </IconContainer>
          <Badge
            textColor={theme === 'pink' ? colors.pink : props.textColor }
            backgroundColor={theme === 'pink' ? colors.white : props.checkBackgroundColor}
          >
            {props.promoCode}
          </Badge>
        </PromoCodeContainer>

        {!!props.clearPromo && (
          <ClearPromoContainer
            onClick={props.clearPromo}
            color={props.textColor}
          >
            Remove
          </ClearPromoContainer>
        )}
      </TopRow>
      <PromoAdded $theme={theme}>Promo code added</PromoAdded>
    </>
  )
}

const IconContainer = styled.span`
  height: 24px;
  width: 24px;
  background-color: ${(props: any): string =>
    props.checkBackgroundColor || colors.orange};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
`
const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`
const Badge = styled.div`
  background-color: ${(props: any): string => props.backgroundColor || colors.blue};
  color: ${(props: any): void => props.textColor || colors.white};
  text-transform: uppercase;
  border-radius: 26px;
  padding: 0 9px;
  display: flex;
  align-items: center;
  height:30px;
  font-family: 'Good Sans Bold';
  font-size: 12px;
  line-height: 18px;
  margin: 0 0 0 8px;

  ${(props: any): string => config(props).media.md`
    height: 30px;
    padding: 0 12px;
  `}
`
const PromoAdded = styled.p`
  font-size: 12px;
  line-height: 18px;
  color: ${(props: any): string => props.$theme === 'pink' ? colors.white : colors.tintOrange};
  font-family: 'Good Sans Regular';
  margin: 10px 0 10px 32px;
  align-self: flex-start;
`
const PromoCodeContainer = styled.div`
  align-items: center;
  display: flex;
`
const ClearPromoContainer = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: ${(props: any): string => props.color || colors.white};
  font-family: 'Good Sans Regular';
  text-decoration: underline;
  cursor: pointer;
`
